import { IInitialBrandState } from 'interfaces/brand.interface';

const initialBrandState: IInitialBrandState = {
  brand: null,
  isLoading: false,
  getBrand: () => Promise.resolve(false),
  shareDataWithBrand: () => Promise.resolve(false),
};

export default initialBrandState;
